module.exports = __webpack_public_path__ + "img/good.56ab122e.png";